/**
 * @fileoverview v0.18.0 Enhanced Schema Index - Infrastructure Aligned
 * Complete transformation with Infrastructure audit findings integrated
 * New: Auth, Jobs, Real-time, Enhanced schemas, Canonical /api/infra/* routes
 */

// Enhanced domain-separated schemas
export * from './portfolio.js';    // Enhanced: account_type, exchange, currency
export * from './market.js';       // Enhanced: universe, timeframes, precomputed indicators
export * from './ml.js';           // Enhanced: ta_fingerprint, bar_id confirmed in DB
export * from './trading.js';      // Enhanced: trading accounts, new account types
export * from '../routes/routes.js';       // Enhanced: canonical /api/infra/* pattern
export * from './helpers.js';      // Enhanced: idempotency, query normalization

// NEW v0.18.0 domains
export * from './auth.js';         // NEW: Modern Supabase auth with JWKS
export * from './jobs.js';         // NEW: Unified jobs system

// NEW v0.18.0 enhancements (Management improvements)
export * from './endpoint-meta.js';   // NEW: Auth matrix & performance SLAs
export * from './deprecation.js';     // NEW: Deprecation policy & warnings  
export * from './pagination.js';      // NEW: Standardized pagination & filtering
export * from './streaming.js';       // NEW: WebSocket/SSE contracts
export * from './marketplace.js';     // NEW: Marketplace stubs with comingSoon

// Version information (imported from fingerprint.ts to avoid duplication)
export const SCHEMA_VERSION = '1.1.0' as const;
export const RELEASE_DATE = '2025-10-12' as const;

// Infrastructure alignment metadata
export const INFRASTRUCTURE_ALIGNMENT = {
  database_migrations_included: [
    '20250910000001_add_missing_v017_columns.sql',
    '20250916000004_fix_v017_schema.sql', 
    '20250916000005_market_data_system.sql',
    '20250916000006_add_v017_portfolio_fields.sql',
    '20250916000007_jobs_system_minimal.sql'
  ],
  new_tables_supported: [
    'trading.accounts',
    'market.universe', 
    'market.timeframes',
    'market.ingestion_status',
    'market.bars',
    'market.indicators',
    'jobs.jobs',
    'jobs.job_runs', 
    'jobs.job_run_logs'
  ],
  canonical_routes: '/api/infra/*',
  legacy_support_until: 'v0.20.0'
} as const;
